import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "antd";
import { RightOutlined, ArrowDownOutlined } from "@ant-design/icons";
import SelectPriceOption from "./SelectPriceOption";
import SelectPaymentMethod from "./SelectPaymentMethod";
import OrderBumps from "./OrderBumps";
import { NotNullUndefined, paymentMethodValid } from "../../../utils/helper";
//import useMediaQuery from "use-media-antd-query";
import { BuyerInvoiceInfo } from "utils/helper";
import { useInView } from "react-intersection-observer";
import CustomButton from "Components/CustomButton";
import useMediaQuery from "use-media-antd-query";

const isWidget = window?.location?.hash?.substr(1) === "widget";

const Options = ({ productData, data, actionHandler, step, customStyle }) => {
  const { t } = useTranslation();
  const colSize = useMediaQuery();
  const mobileSizes = ["xs", "sm", "md"];
  const isMobileSize = mobileSizes.includes(colSize);
  const showBillingContainer = data?.format === "one-time-service" || data?.required_checkout_billing === true;

  const ref = useRef(null);
  // const colSize = useMediaQuery();
  const validatePaymentMethod = paymentMethodValid(data, undefined, t);
  // const _validatePaymentAction = () => {
  //   return paymentMethodValid(data);
  // };

  // Use `inView` (viewport intersection only) and NOT `trackVisibility`/`isVisible`,
  // which is occlusion-aware and falsely fires when a modal mask covers the button.
  const { ref: nextButtonRef, inView: nextButtonInView } = useInView({
    threshold: 1,
  });

  return (
    <div
      className="options-container"
      ref={ref}
      style={customStyle?.primary?.backgroundColor ? { "--pm-accent": customStyle.primary.backgroundColor } : undefined}
    >
      <SelectPriceOption productData={productData} data={data} actionHandler={actionHandler} />

      <SelectPaymentMethod data={data} actionHandler={actionHandler} />

      {NotNullUndefined(data?.payment_method) && NotNullUndefined(data?.price_option) && (
        <>
          <OrderBumps isMobileSize={isMobileSize} step={step} productData={productData} data={data} actionHandler={actionHandler} customStyle={customStyle} />
          {!validatePaymentMethod.status && (
            <div className="button" style={{ marginTop: 40, display: "flex", justifyContent: "center" }}>
              <Alert message={t("options.paymentMethodUnavailable")} description={validatePaymentMethod.data} type="error" showIcon />
            </div>
          )}
          <div className="button" style={{ marginTop: 40 }}>
            <CustomButton
              customRef={nextButtonRef}
              disabled={!validatePaymentMethod.status}
              size="large"
              type="primary"
              block
              htmlType="submit"
              buttonStyle={customStyle}
              // className="submit-button"
              onClick={() => {
                actionHandler("options");
                // ref.current?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              {t("options.makePayment")} <RightOutlined />
            </CustomButton>
          </div>

          {data?.is_teaser !== true && data?.format !== "one-time-service" && showBillingContainer !== true && (
            <div className="billing-data-notice">
              <BuyerInvoiceInfo isWidget={isWidget} data={data?.thankyou_page} />
            </div>
          )}

          {nextButtonInView === false && (
            <div className="nextButtonFixed">
              <CustomButton
                disabled={!validatePaymentMethod.status}
                type="primary"
                htmlType="submit"
                addClass="submit-button-smaller"
                buttonStyle={customStyle}
                onClick={() => {
                  actionHandler("options");
                  // ref.current?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {t("options.makePayment")} <RightOutlined />
              </CustomButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Options;
